import { render, staticRenderFns } from "./IconArrowBack.vue?vue&type=template&id=74c33eb6"
import script from "./IconArrowBack.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconArrowBack.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports